// @flow
import React from 'react';
// Material-ui
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import { Tab, Tabs } from 'material-ui/Tabs';
import Toggle from 'material-ui/Toggle';
import Popover from 'material-ui/Popover';
// icon
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ContentAdd from 'material-ui/svg-icons/content/add';
import IconEdit from 'material-ui/svg-icons/editor/mode-edit';
import Photo from 'material-ui/svg-icons/image/photo';
import IconArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
// Loader
import CircularProgress from 'material-ui/CircularProgress';
//
import toTranslit from '../../util/cyrillic-to-translit';
//
import * as MediaFileAddMutation from '../../mutations/MediaFileAddMutation';
import modernEnvironment from '../../lib/RelayUtils';
import Rars from '../rars/Rars';

// config
import { backendUrl, staticUrl } from '../../lib/config';
// player
import Player from '../player/Player';
// Topics
import TopicSelector from '../TopicSelector';
//
import TextCharCount from '../ui/charCounter';
// style
import { modalStyle, btnStyle } from './modal-style';
import { formElement } from '../../lib/styles';
import './media-meta-info.css';
import dropDownStyle from '../ui/dropdown-style';
import '../ui/hr.css';
import * as MediaFileEditMutation from '../../mutations/MediaFileEditMutation';

type Props = {
    getOpenState: Function,
    open: boolean,
    sendMediaState: Function,
    setInfo: Object,
    type: string,
    viewer: Object,

};
type State = {
    alt: ?string,
    anchorEl?: any,
    authors: Array<?string>,
    dataStatus: boolean,
    description: ?string,
    filename: string,
    id: string,
    open: boolean,
    openCategory: boolean,
    openStatus: boolean,
    preview: ?string,
    rating: ?string,
    ratingActive: boolean,
    seoDescription: ?string,
    seoKeywords: ?string,
    seoTitle: ?string,
    show: ?string,
    showTitle: ?string,
    statusTitle: ?string,
    slug: ?string,
    status: ?string,
    state: ?string,
    title: ?string,
    topics: Array<Object>,
    type: string,
};

const VideoPlayer = (url) => {
    if (url.data === null || url.data === '') {
        return (
            <div />
        );
    }
    const config = {
        sources: [{ src: url.data, type: 'video/mp4' }],
        autoplay: false,
    };
    return (
        <div style={{ position: 'relative' }}>
            <Player
                style={{
                    width: '100%',
                    height: 450,
                }}
                config={config}
            />
        </div>
    );
};

const filterAssets = [
    {
        id: 'filter_stream',
        title: 'Стрим',
    }, {
        id: 'filter_news',
        title: 'Новость',
    }, {
        id: 'filter_article',
        title: 'Статья',
    }, {
        id: 'filter_tv',
        title: 'ТВ',
    },
];

const statusAssets = [
    {
        id: 'available',
        title: 'Опубликовано',
    }, {
        id: 'deleted',
        title: 'Удалено',
    },
];

class MediaMetaInfo extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const info = props.setInfo;
        const isInfo = info !== undefined;
        this.state = {
            alt: isInfo ? info.alt : '',
            authors: isInfo ? info.authors : [],
            dataStatus: false,
            description: isInfo ? info.description : '',
            filename: isInfo ? info.filename : 'null',
            id: isInfo ? info.id : 'null',
            open: false,
            openCategory: false,
            openStatus: false,
            preview: isInfo ? info.preview : '',
            rating: isInfo ? info.rating : '',
            ratingActive: false,
            seoDescription: isInfo ? info.seoDescription : '',
            seoKeywords: isInfo ? info.seoKeywords : '',
            seoTitle: isInfo ? info.seoTitle : '',
            show: isInfo ? info.show : '',
            showTitle: '',
            statusTitle: '',
            slug: isInfo ? info.slug : '',
            status: isInfo ? info.status : '',
            state: isInfo ? info.state : '',
            title: isInfo ? info.title : '',
            topics: [],
            type: isInfo ? info.type : 'null',
        };
    }

    componentWillMount() {
        this.clearState();
        this.setState({ open: this.props.open });
        if (this.props.setInfo) {
            this.changeState(this.props.setInfo);
        }
    }

    componentWillReceiveProps(nextProps: Object) {
        if (nextProps.open !== this.state.open) {
            this.setState({ open: nextProps.open });
        }
        if (this.props.setInfo && this.props.setInfo.id === this.state.id) {
            return;
        }
        this.clearState();
        if (nextProps.setInfo === null) {
            this.setState({ dataStatus: false });
            return;
        }
        if (nextProps.setInfo) {
            this.changeState(nextProps.setInfo);
        }
    }

    onUpdateShowTitle = (showId?: string, type: string) => {
        if (!showId) {
            return;
        }
        let selectedAssets;
        if (type === 'show') {
            selectedAssets = filterAssets.filter(item => item.id === showId);
            if (selectedAssets.length) {
                this.setState({ showTitle: `${selectedAssets[0].title}` });
            }
        }
        if (type === 'status') {
            selectedAssets = statusAssets.filter(item => item.id === showId);
            if (selectedAssets.length) {
                this.setState({ statusTitle: `${selectedAssets[0].title}` });
            }
        }
    };

    onPreviewChange = (event: Object) => {
        const file = event.target.files[0];

        if (file.type.indexOf('image/') !== 0) {
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        if (this.state.preview) {
            formData.append('destFile', this.state.preview);
        }

        fetch(`${backendUrl}/upload3`, {
            method: 'POST',
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(resp => resp.json())
            .then((data) => {
                if (data.filename) {
                    this.setState({ preview: '' });
                    this.setState({ preview: data.filename });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    onMenuClick = (event: Object, type: string) => {
        event.preventDefault();
        document.getElementById(`${type}-select-menu`).classList.add('is-active');
        this.setState({
            anchorEl: event.currentTarget,
        });
        if (type === 'show') {
            this.setState({
                openCategory: true,
            });
            return;
        }
        this.setState({
            openStatus: true,
        });
    };

    onTitleChanged = (event: any, newValue: string) => {
        const text = newValue.trim();
        this.setState({
            title: newValue,
            slug: toTranslit(text),
        });
    };

    onSlugChanged = (newValue: string) => {
        const text = newValue.trim();
        this.setState({
            slug: toTranslit(text),
        });
    };

    clearState = () => {
        this.setState({
            openCategory: false,
            title: '',
            alt: '',
            description: '',
            preview: null,
            rating: '0',
            show: '',
            showTitle: '',
            authors: [],
            topics: [],
            slug: '',
            seoTitle: '',
            seoDescription: '',
            seoKeywords: '',
            dataStatus: false,
        });
    };

    /**
     * Сохранить мета-информацию
     */
    save = () => {
        const baseParams = {
            id: this.state.id,
            title: this.state.title ? this.state.title.trim() : '',
            description: this.state.description,
            alt: this.state.alt,
            filename: this.state.filename,
            rating: this.state.rating,
            authors: this.state.authors,
            type: this.state.type,
            status: 'created',
            state: this.state.state,
            preview: this.state.preview,
            topics: this.state.topics.map(topic => topic.id),
            show: this.state.show ? this.state.show : '',
            slug: this.state.slug,
            seoTitle: this.state.seoTitle,
            seoDescription: this.state.seoDescription,
            seoKeywords: this.state.seoKeywords,
        };

        if (baseParams.id) {
            MediaFileEditMutation.commit(modernEnvironment, baseParams, (error) => {
                this.props.sendMediaState(baseParams);
                this.handleClose();
                if (baseParams.state === 'deleted') {
                    const element = document.getElementById(baseParams.id);
                    if (element) {
                        element.style.display = 'none';
                    }
                }
            });
        } else {
            MediaFileAddMutation.commit(modernEnvironment, baseParams, (error, result) => {
                this.handleClose();
            });
        }
    };

    handleChangeTab = (value: number) => {
        document.getElementsByClassName('pcd-tab-active')[0].classList.remove('pcd-tab-active');
        document.getElementsByClassName(`pcd-tab${value}`)[0].classList.add('pcd-tab-active');
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    };

    /**
     * Закрытие окна без сохранения
     */
    handleClose = () => {
        this.clearState();
        this.props.getOpenState({ open: false });
    };

    changeState = (props: any) => {
        const newState = {};
        for (const key in props) {
            if ({}.hasOwnProperty.call(props, key)) {
                newState[key] = props[key] ? props[key] : '';
            }
        }
        this.setState(newState);
        this.setState({
            ratingActive: Boolean(props.rating),
            dataStatus: true,
        });
        if (props.type === 'video' && !props.preview) {
            this.setState({
                preview: `${props.filename.replace('.mp4', '')}/preview.jpg`,
            });
        }
        setTimeout(() => {
            console.log(this.state);
        }, 250);
        this.onUpdateShowTitle(props.show, 'show');
        this.onUpdateShowTitle(props.state, 'status');
    };

    selectItem = (e: Object, type: string) => {
        document.getElementById(`${type}-select-menu`).classList.remove('is-active');
        if (type === 'show') {
            this.setState({
                show: e.id,
                openCategory: false,
            });
        }
        if (type === 'status') {
            this.setState({
                state: e.id,
                openStatus: false,
            });
        }
        this.onUpdateShowTitle(e.id, type);
    };

    showLoader = () => (
        <div className="loader-wrapper">
            <CircularProgress size={80} thickness={7} />
        </div>
    );

    renderCategoryList = () => (
        <div>
            <small
                style={{
                    ...formElement.smallTitle,
                    marginTop: 18,
                    marginBottom: 10,
                }}
            >
                Категория
            </small>
            <div>
                <label
                    id="show-select-menu"
                    onClick={e => this.onMenuClick(e, 'show')}
                    className="mediametainfo-category--title"
                    role="presentation"
                >
                    {this.state.showTitle}
                    <div className="category-icon">
                        <IconArrow/>
                    </div>
                </label>
            </div>
            <Popover
                className="mediainfo-popover"
                open={this.state.openCategory}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                labelStyle={{ fontSize: 14, top: 9 }}
                style={{
                    paddingBottom: 16,
                    overflowY: 'auto',
                    minWidth: 270,
                }}
                floatingLabelText="Категория"
                value={this.state.show}
                onRequestClose={(e) => {
                    document.getElementById('show-select-menu').classList.remove('is-active');
                    this.setState({ openCategory: false });
                }}
            >
                {
                    filterAssets.map((asset, index) => (
                        <MenuItem
                            style={dropDownStyle.item}
                            key={index}
                            value={asset.id}
                            primaryText={asset.title}
                            onClick={() => this.selectItem(asset, 'show')}
                        />
                    ))
                }
            </Popover>
        </div>
    );

    renderStatusList = () => (
        <div>
            <small
                style={{
                    ...formElement.smallTitle,
                    marginTop: 18,
                    marginBottom: 10,
                }}
            >
                Статус
            </small>
            <div>
                <label
                    id="status-select-menu"
                    onClick={e => this.onMenuClick(e, 'status')}
                    className="mediametainfo-category--title"
                    role="presentation"
                >
                
                    {this.state.statusTitle}
                    <div className="category-icon">
                        <IconArrow />
                    </div>
                </label>
            </div>
            <Popover
                className="mediainfo-popover"
                open={this.state.openStatus}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                labelStyle={{ fontSize: 14, top: 9 }}
                style={{
                    paddingBottom: 16,
                    overflowY: 'auto',
                    minWidth: 270,
                }}
                floatingLabelText="Статус"
                value={this.state.state}
                onRequestClose={(e) => {
                    document.getElementById('status-select-menu').classList.remove('is-active');
                    this.setState({ openStatus: false });
                }}
            >
                {
                    statusAssets.map((status, index) => (
                        <MenuItem
                            style={dropDownStyle.item}
                            key={index}
                            value={status.id}
                            primaryText={status.title}
                            onClick={() => this.selectItem(status, 'status')}
                        />
                    ))
                }
            </Popover>
        </div>
    );

    renderPreview = () => {
        const hash = Math.random();
        if (this.state.preview) {
            return (
                <section>
                    <small
                        style={{
                            ...formElement.small,
                            display: 'block',
                            marginTop: 17,
                        }}
                    >
                        Превью
                    </small>
                    <div className="mediametainfo-preview">
                        <div className="mediametainfo-preview--img">
                            <img
                                src={`${staticUrl}/${this.state.preview}?${hash}`}
                                style={{ maxWidth: '255px' }}
                                alt="video preview"
                            />
                        </div>
                        <div className="mediametainfo-preview--tool">
                            <IconButton
                                style={{ padding: 0, height: 28, width: 44 }}
                                onClick={() => this.setState({ preview: null })}
                            >
                                <CloseIcon hoverColor="#542376" color="#777777" />
                            </IconButton>
                            <div style={{ margin: '-2px 0 0px 1px ' }}>
                                {this.renderPreviewBtn(<IconEdit color="#777777" hoverColor="#542376" />)}
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
        return (
            <section
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '6px 2px 1px 0',
                    borderBottom: 'solid 1px #E0E0E0',
                }}
            >
                <ContentAdd/>
                {this.renderPreviewBtn(<Photo color="#777777" hoverColor="#542376" />)}
            </section>
        );
    };

    renderPreviewBtn = (icon: any) => (
        <IconButton
            containerElement="label"
            style={{ maxWidth: 12, height: 42, padding: 9 }}
            className="btn__hover_empty"
        >
            {icon}
            <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={e => this.onPreviewChange(e)}
            />
        </IconButton>
    );

    render() {
        const topics = this.props.viewer.viewer;
        const inputStyle = { padding: 3 };
        const action = [
            <FlatButton
                key="random-key"
                label="Сохранить"
                backgroundColor="#46bc98"
                hoverColor="#542376"
                rippleColor="#989494"
                style={{ ...btnStyle, width: 181 }}
                labelStyle={{ fontWeight: 'normal', display: 'block', marginTop: -1 }}
                onClick={this.save}
            />,
        ];
        let editFileTitle;
        switch (this.state.type) {
        case 'video':
            editFileTitle = 'Параметры видео';
            break;
        case 'image':
            editFileTitle = 'Параметры изображение';
            break;
        default:
            editFileTitle = 'Параметры';
            break;
        }

        return (
            <Dialog
                open={this.state.open}
                modal={false}
                contentStyle={{
                    ...modalStyle.main,
                    width: 865,
                    maxWidth: 865,
                    position: 'relative',
                    padding: 0,
                }}
                bodyStyle={{
                    ...modalStyle.body,
                    padding: '0 0 30px 0',
                    borderTop: 'none',
                    borderBottom: 'none',
                }}
                overlayStyle={modalStyle.overlay}
                onRequestClose={this.handleClose}
            >
                <hr className="tab-shadow" />
                <div
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 5,
                    }}
                >
                    <IconButton
                        onClick={this.handleClose}
                    >
                        <CloseIcon hoverColor="#542376" />
                    </IconButton>
                </div>
                <Tabs
                    style={{ marginTop: -3 }}
                    tabItemContainerStyle={{
                        background: 'white',
                        marginTop: 7,
                        width: 800,
                    }}
                    inkBarStyle={{
                        background: '#542376',
                        width: '400px',
                        height: 3,
                        marginTop: -3,
                    }}
                    onChange={this.handleChangeTab}
                >
                    <Tab
                        label={editFileTitle}
                        className="pcd-tab pcd-tab0 pcd-tab-active"
                        value={0}
                    >
                        {this.state.dataStatus &&
                        <div className="tab-inner--wrapper">
                            <div className="tab-inner--inner" style={{ paddingTop: 25 }}>
                                <TextField
                                    floatingLabelText="Название"
                                    style={{ ...formElement.textField, fontSize: 14, marginTop: 1 }}
                                    floatingLabelStyle={formElement.label}
                                    underlineStyle={{ bottom: 6 }}
                                    value={this.state.title}
                                    maxLength="90"
                                    fullWidth={true}
                                    floatingLabelFixed={true}
                                    inputStyle={inputStyle}
                                    onChange={(event, value) => this.onTitleChanged(event, value)}
                                    // onChange={(event, newValue) => this.setState({ title: newValue })}
                                />
                                {this.state.type === 'video' &&
                                <TextField
                                    floatingLabelText="Альт"
                                    style={{ ...formElement.textField, fontSize: 14, marginTop: 1 }}
                                    floatingLabelStyle={formElement.label}
                                    underlineStyle={{ bottom: 6 }}
                                    value={this.state.alt}
                                    multiLine={true}
                                    maxLength="90"
                                    fullWidth={true}
                                    floatingLabelFixed={true}
                                    inputStyle={inputStyle}
                                    onChange={(event, newValue) => this.setState({ alt: newValue })}
                                />
                                }
                                <TextField
                                    floatingLabelText="Описание"
                                    style={{ ...formElement.textField, fontSize: 14, marginTop: 1 }}
                                    floatingLabelStyle={formElement.label}
                                    underlineStyle={{ bottom: 6 }}
                                    value={this.state.description}
                                    multiLine={true}
                                    maxLength="250"
                                    fullWidth={true}
                                    floatingLabelFixed={true}
                                    inputStyle={inputStyle}
                                    onChange={(event, newValue) => this.setState({ description: newValue })}
                                />
                                <div style={{ marginTop: 7 }}>
                                    <TextCharCount
                                        maxChar={250}
                                        currentChar={this.state.description ? this.state.description.length : 0}
                                    />
                                </div>

                                {this.state.type === 'video' && this.renderPreview()}

                                <section
                                    style={{ marginTop: this.state.type === 'video' ? 33 : 25 }}
                                    id="mediameta-topic"
                                    className="topic-selector--cloud-wrapper"
                                >
                                    <TopicSelector
                                        underline="mediameta-topic"
                                        type="cloud"
                                        viewer={topics}
                                        value={this.state.topics}
                                        onChange={v => this.setState({ topics: v })}
                                    />
                                </section>

                                {this.state.type === 'video' &&
                                <section className="mediainfo--seo">
                                    <TextField
                                        floatingLabelText="Slug"
                                        style={{
                                            ...formElement.textField,
                                            fontSize: 14,
                                            marginTop: 12,
                                            marginBottom: 5,
                                        }}
                                        floatingLabelStyle={formElement.label}
                                        underlineStyle={{ bottom: 6 }}
                                        value={this.state.slug}
                                        multiLine={true}
                                        maxLength="250"
                                        fullWidth={true}
                                        floatingLabelFixed={true}
                                        inputStyle={inputStyle}
                                        onChange={(event, value) => this.onSlugChanged(value)}
                                    />
                                    <div style={{ marginTop: 7 }}>
                                        <TextCharCount
                                            maxChar={250}
                                            currentChar={this.state.slug ? this.state.slug.length : 0}
                                        />
                                    </div>

                                    <TextField
                                        floatingLabelText="SEO тайтл"
                                        style={{ ...formElement.textField, fontSize: 14, marginTop: -3 }}
                                        floatingLabelStyle={formElement.label}
                                        underlineStyle={{ bottom: 6 }}
                                        value={this.state.seoTitle}
                                        multiLine={true}
                                        maxLength="250"
                                        fullWidth={true}
                                        floatingLabelFixed={true}
                                        inputStyle={inputStyle}
                                        onChange={(event, newValue) => this.setState({ seoTitle: newValue })}
                                    />

                                    <TextField
                                        floatingLabelText="SEO description"
                                        style={{
                                            ...formElement.textField,
                                            fontSize: 14,
                                            marginTop: 12,
                                            marginBottom: 8,
                                        }}
                                        floatingLabelStyle={formElement.label}
                                        underlineStyle={{ bottom: 6 }}
                                        value={this.state.seoDescription}
                                        multiLine={true}
                                        maxLength="250"
                                        fullWidth={true}
                                        floatingLabelFixed={true}
                                        inputStyle={inputStyle}
                                        onChange={(event, newValue) => this.setState({ seoDescription: newValue })}
                                    />

                                    <TextField
                                        floatingLabelText="SEO keywords"
                                        style={{ ...formElement.textField, fontSize: 14, marginTop: 1 }}
                                        floatingLabelStyle={formElement.label}
                                        underlineStyle={{ bottom: 6 }}
                                        value={this.state.seoKeywords}
                                        multiLine={true}
                                        maxLength="250"
                                        fullWidth={true}
                                        floatingLabelFixed={true}
                                        inputStyle={inputStyle}
                                        onChange={(event, newValue) => this.setState({ seoKeywords: newValue })}
                                    />
                                </section>
                                }

                                <section
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        padding: '17px 2px 1px 1px',
                                    }}
                                >
                                    <div style={{ flexBasis: '50%', alignSelf: 'flex-start' }}>
                                        <section style={{ display: 'flex' }}>
                                            <Rars
                                                style={{ width: 321 }}
                                                disabled={!this.state.ratingActive}
                                                value={this.state.rating}
                                                onChange={v => this.setState({ rating: v })}
                                            />
                                            <div style={{ margin: '41px 0 0 -45px' }}>
                                                <Toggle
                                                    label=""
                                                    toggled={this.state.ratingActive}
                                                    onToggle={(event, isInputChecked) => {
                                                        this.setState({ ratingActive: isInputChecked });
                                                        if (!isInputChecked) {
                                                            this.setState({ rating: '' });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </section>
                                        <TextField
                                            floatingLabelText="Подпись"
                                            style={{
                                                ...formElement.textField,
                                                fontSize: 14,
                                                lineHeight: 1.29,
                                                marginTop: 18,
                                                width: 320,
                                            }}
                                            underlineStyle={{ bottom: 5 }}
                                            multiLine={true}
                                            floatingLabelStyle={{ ...formElement.label, top: 31 }}
                                            value={this.state.authors && this.state.authors.length ?
                                                this.state.authors[0] :
                                                ''
                                            }
                                            maxLength="250"
                                            fullWidth={true}
                                            floatingLabelFixed={true}
                                            onChange={(event, newValue) => this.setState({ authors: newValue })}
                                        />
                                    </div>
                                    <div style={{ flexBasis: '50%', alignSelf: 'flex-start', paddingLeft: 16 }}>
                                        {this.state.type === 'video' && this.renderCategoryList()}
                                        {this.renderStatusList()}
                                    </div>
                                </section>

                                <div
                                    style={{
                                        padding: '27px 0 0',
                                        textAlign: 'right',
                                    }}
                                >
                                    {action}
                                </div>
                            </div>
                        </div>
                        }
                        {!this.state.dataStatus && this.showLoader()}
                    </Tab>
                    <Tab
                        label="Просмотр"
                        className="pcd-tab pcd-tab1"
                        value={1}
                    >
                        {this.state.dataStatus &&
                        <div className="tab-inner--wrapper">
                            <div className="tab-inner--inner">
                                <div>
                                    {this.state.type === 'video' &&
                                    <div className="mediametainfo-preview--video">
                                        <VideoPlayer data={`${staticUrl}/${this.state.filename}`} />
                                    </div>
                                    }
                                    {this.props.type === 'image' &&
                                    <div className="mediametainfo-preview--video">
                                        {this.state.filename && <img
                                            src={`${staticUrl}/${this.state.filename}`}
                                            alt=""
                                            style={{
                                                maxWidth: 805,
                                                maxHeight: 450,
                                            }}
                                        />
                                        }
                                        {!this.state.filename && <span>Файл еще не готов.</span>}
                                    </div>
                                    }
                                    <div
                                        style={{
                                            padding: '27px 0 0',
                                            textAlign: 'right',
                                        }}
                                    >
                                        {action}
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        {!this.state.dataStatus && this.showLoader()}
                    </Tab>
                </Tabs>
            </Dialog>
        );
    }
}

export default MediaMetaInfo;



// WEBPACK FOOTER //
// src/components/media/MediaMetaInfo.js